import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import type { WoundResponse } from '../../services/api';

interface DeleteWoundDialogProps {
  wound: WoundResponse | null;
  isDeleting: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteWoundDialog: React.FC<DeleteWoundDialogProps> = ({
  wound,
  isDeleting,
  error,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={!!wound}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Wound</DialogTitle>
        </DialogHeader>
        {error ? (
          <p className='text-sm text-destructive'>{error}</p>
        ) : (
          <p className='text-sm text-muted-foreground'>
            Are you sure you want to delete the wound at{' '}
            <strong>{wound?.location}</strong>? This cannot be undone.
          </p>
        )}
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          {!error && (
            <Button
              variant='destructive'
              onClick={onConfirm}
              disabled={isDeleting}
            >
              {isDeleting && <Loader2 className='h-4 w-4 mr-1 animate-spin' />}
              Delete
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteWoundDialog;
